import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fourPlaceHolder } from "modules/utilities/utility";

function NpsFeedbackTable({ data, isLoading }) {
  const [sortedData, setSortedData] = useState(data?.feedbacks);

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  return (
    <div className="mt-2">
      <div className="mt-1 shadow rounded">
        <div className="d-flex table-head rounded-top">
          <span className="p-3 fw-bold text-black flex-1">Customer Name</span>
          <span className="p-3 fw-bold text-black flex-1 text-center">Agent Name</span>
          <span className="p-3 fw-bold text-black flex-1 text-center">
            Gender
          </span>
          <span className="p-3 fw-bold text-black flex-1 text-center">
            Customer Rating
          </span>
          <span className="p-3 fw-bold text-black flex-1 text-center">Custom input</span>
          <span className="p-3 fw-bold text-black flex-1 text-center"> Created At</span>
        </div>
        {isLoading ? (
          fourPlaceHolder()
        ) : sortedData && sortedData?.length ? (
          sortedData?.map((feedback, index) => {
            return (
              <div
                className={`d-flex table-row border- border-top-0 ${
                  index === sortedData?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-2 flex-1 text-break text-wrap">
                  <Link to={`/lead-details/${feedback?.case_id}`}>
                    <div className="fw-bold text-primary">
                      {" "}
                      {feedback?.user?.first_name}{" "}
                    </div>
                  </Link>
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {feedback?.rep?.first_name || "-"}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {feedback?.user.gender == "M" ? "Male" : "Female"}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {feedback?.responses[0]?.reply}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {feedback?.responses[1]?.reply}
                </span>
                <span className="p-2 flex-1 text-break text-black text-wrap text-center">
                  {moment(feedback?.createdAt).format("DD/MM/YY HH:mm:ss")}
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default NpsFeedbackTable;
